import { Button } from "components/DesignSystem/Button/Button";
import { LargeCard } from "components/home/Home";
import { MAILROOM } from "constants/addons";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";
import { setAddonData, setAddonType } from "store/slices/addons";

export const MailRoomHomeCard = ({
  isMailroomSubscribed,
}: {
  isMailroomSubscribed: boolean;
}) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const entityId = useCurrentEntityId();
  const { data: allSubscriptions = [] } = useGetSubscriptionsQuery(
    {
      groupId,
      entityId,
    },
    { skip: !entityId || !groupId }
  );

  const history = useHistory();
  const { url } = useRouteMatch();

  const dispatch = useDispatch();

  const mailroomSubscriptionData = allSubscriptions?.find(
    (subscription) => subscription.subscription_type === "MAILROOM"
  );

  const { amount, stripe_coupon } = mailroomSubscriptionData || {};
  const updatedAmount = stripe_coupon?.discounted_amount.toString() || amount;

  const updatedMailroomSubscription = {
    ...mailroomSubscriptionData,
    amount: Number(updatedAmount),
  };

  const { link } = useConstructInternalLink();

  const openMailroomAddon = () => {
    if (isMailroomSubscribed) {
      history.push(link(`${url}/inbox`));
      return;
    }

    dispatch(setAddonData(updatedMailroomSubscription));
    dispatch(setAddonType(MAILROOM));
  };

  const btnText = isMailroomSubscribed ? "View mails" : "Get started";

  if (!mailroomSubscriptionData) {
    return null;
  }

  return (
    <>
      <div className="t-pb-8 t-grid t-gap-6 t-flex-wrap md:t-grid-cols-[repeat(auto-fill,minmax(462px,1fr))] t-grid-cols-[repeat(auto-fill,1fr)]">
        <LargeCard>
          <div
            role="button"
            onClick={openMailroomAddon}
            className="t-border t-border-solid t-border-neutral-0 t-rounded-lg t-p-5 t-h-full t-w-full t-bg-[url('static/images/MailRoomHomePageBG.svg')] t-bg-auto t-bg-no-repeat t-bg-right"
          >
            <div className="t-h-full t-w-1/2 t-flex t-flex-col t-justify-between">
              <div className="t-w-full">
                <div className="t-text-subtitle t-text-text-100">
                  Inkle Mailroom
                </div>
                <span className="t-text-body-sm t-text-text-30">
                  View and manage all your mails in one place.
                </span>
              </div>
              <div>
                <Button size="small">{btnText}</Button>
              </div>
            </div>
          </div>
        </LargeCard>
      </div>
    </>
  );
};
